import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  constructor() { }

  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    // ensure current page isn't out of range
    if (currentPage < 1) { 
        currentPage = 1; 
    } else if (currentPage > totalPages) { 
        currentPage = totalPages; 
    }
    
    let startPage: number, endPage: number;

    // //console.log(startPage);
    // //console.log(endPage);

//console.log("currentPage", currentPage)
//console.log("totalPages", totalPages)
    if (totalPages <= 10) {
      // //console.log("totalPages");
      // //console.log(totalPages);
        // less than 10 total pages so show all
        if (currentPage == 1) {
          if(totalPages<6){
            startPage = 1;
            endPage = totalPages;
          }else{
            startPage = 1;
            endPage = totalPages;
          }
          
      } else if (currentPage == 2) {
        if(totalPages<6){
          startPage = 1;
          endPage = totalPages;
        }else{
          startPage = 1;
          endPage = totalPages;
        }
      } else if (currentPage == 3) {
        if(totalPages<6){
          startPage = 1;
          endPage = totalPages;
        }else{
          startPage = 1;
          endPage = totalPages;
        }
      } else {
        startPage = 1;
        endPage = totalPages;
      }


    } else {
        // more than 10 total pages so calculate start and end pages
        if (currentPage == 1) {
          startPage = 1;
          endPage = 9;
      } 
      else if (currentPage == 2) {
          startPage = 1;
          endPage = 9;
      } else if (currentPage == 3) {
        startPage = 1;
        endPage = 9;
      } 
      else if (currentPage <= 6) {
            startPage = 1;
            endPage = 9;
        } else if ((currentPage*1) + 4 >= totalPages) {
            startPage = totalPages - 8;
            endPage = totalPages;
      //console.log("in this")
        } else {
            startPage = (currentPage*1) - 3;
            endPage = (currentPage*1) + 4;
      //console.log("in else")

        }
    }

    //console.log("startPage",startPage)
    //console.log("endPage",endPage)

    // calculate start and end item indexes
    let startIndex = ((currentPage*1) - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

    // return object with all pager properties required by the view
    return {
        totalItems: totalItems,
        currentPage: currentPage,
        pageSize: pageSize,
        totalPages: totalPages,
        startPage: startPage,
        endPage: endPage,
        startIndex: startIndex,
        endIndex: endIndex,
        pages: pages
    };
  }
}
